/**
 * @module components\ViewSr
 */
import core from '@/services/core';
import sToast from '@/services/sToast';
import store from '@/store';
import axios from 'axios';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { required } from "vuelidate/lib/validators";
import _ from 'lodash';
import * as XLSX from "xlsx";
import stoast from '@/services/sToast';

@Component({
  validations: {
    fromDate: { required },
    toDate: { required },
    finoClientId: { required }
    
    
    
  },
})
export default class ViewSr extends Vue {
  search="";
  pageNumber= 1;
  srStatuses=[];
  selected=[];
  currentPage = this.pageNumber;
  pageNumberToHitAPI = 0;
  recordNumber=1;
  pageNumberToHitAPISr = 0;
  recordNumberSr=1;
  currentPageSr=this.pageNumber;
  modules=[];
  fromDate = "";
  selectedAll=false;
  btnTxt="Search"
  isFilterEnable = false;
  finoClientId = "";
  toDate = "";
  mxDate=moment().format("YYYY-MM-DD");
  superInitData=null;
  headers= [];
  historys= [];
  srData=[]
  srHeaders=[];
  itemsModules=[];
  historyResponse:any={};
  openSr=false;
  transInfo=false;
  json_fields={};
  dataExcel=[];
  fileIdKey='';
  fileIdValue='';
  downloadFile=false;
  downloadFileLoader=true;

  get staticData(){
    return store.getters.staticDataGet;
    }
    tab=store.getters.tabKeyGet.tab
    reqModule=store.getters.tabKeyGet.requestModule

    get moduleClient(){
      return this.itemsModules.filter(obj=>{
        return obj.value==this.finoClientId
      })
    }


    
  viewSrHistory(src,isBtn){
    if(this.$v.$invalid && src=='VIEW'&& isBtn){
      this.$v.$touch();
      return;
    }
    if(src=='VIEW' && isBtn){
      this.historys=[];
    }
    let request={"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": store.getters.sessLoginDataGet.clientId,"fromDate":this.fromDate!=''? moment(this.fromDate).format("DD/MM/YYYY"):'',"toDate": this.toDate!=''?moment(this.toDate).format("DD/MM/YYYY"):'',"requestType": src,"requestModule": this.reqModule,"recordNumber": this.recordNumber,"finoClientId": this.finoClientId,"aggId":  this.moduleClient.length>0? this.moduleClient[0].agg_id:'',"filter_A": "","filter_B": "","filter_C": "","filter_D": "","filter_E": "","tabKey":this.tab};
    core
      .post({
        data: request,
        url: 'fetchFileHist',
        method: 'post'
      })
    .then(response => {
      this.isFilterEnable = true;
      this.btnTxt = "Clear Filters";
      this.historyResponse=response;
     this.fileIdKey=response.txnIdParamName;
     let ans=response.headers.filter(el=>{return el.text===this.fileIdKey})
     this.fileIdValue=ans[0]['value'];
      if(response.historyData.length>0){
        if(isBtn){
          this.historys=[];
          this.dataExcel=[];
          this.counter=0;
        }
        this.historys.push(...response.historyData);
        this.headers=response.headers;
        this.setDrawerState();
        
      }
      if(response.historyData.length<=0){
        //this.historys=[];
      }
    })
    .catch(error => {
      console.log(error)
    });
  }
  addToSelected(srNo){
    if(!this.selected.includes(srNo))
    this.selected.push(srNo);
    else
    {
      const index =  this.selected.indexOf(srNo);

      this.selected.splice(index, 1);

    }
  }

  selectAllSr(){
    
    this.selected=[];
    if( this.selectedAll){
    let actionCoulum=this.fetchSrDataResponse.clickableColumnName;
    let actionIndex='';
    let sr='';
    actionIndex=this.srHeaders.filter(el=>{
      if(el['text']==='SR NUMBER')
      {
        sr=el.value;
      }
      return el['text']==actionCoulum
    })[0]['value'];
    this.srData.forEach(el=>{
      if(el[actionIndex]=='Select' && el[sr]){
        this.selected.push(el[sr])
      }
    })
    //this.cancelRequest()
  }
  }
  showMessages(response,intent){
    stoast.show({
      message: response.responseDesc,
      intent: intent,
      timeout: 5000
    });
  }
cancelRequest(){
  //if(this.selectedAll)
  //this.selectAllSr()
    let request={"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": store.getters.sessLoginDataGet.clientId,"requestType": "WEB","requestModule":store.getters.requestModuleGet,"finoClientId": this.finoClientId,"aggId":  this.moduleClient.length>0? this.moduleClient[0].agg_id:'',"requestFor":this.selectedAll?"SELECT_ALL":"SELECTED_SR","selectedSR":this.selected,"tabKey":this.tab,"requestId":this.fileIdSelected};
    core
      .post({
        data: request,
        url: 'demandCancel',
        method: 'post'
      })
    .then(response => {
      this.openSr=false
      this.showMessages(response,'success');
      this.selected=[];
      this.selectedAll=false;
      this.currentPageSr=1;
      this.recordNumberSr=1;
      this.srData=[]
      this.viewSrHistory("VIEW",true);
    })
    .catch(error => {
      this.openSr=false
      this.showMessages(error,'error');
    });
   
  }

  cancelFile(fileId){
    let request={"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": store.getters.sessLoginDataGet.clientId,"requestType": "WEB","requestModule":store.getters.requestModuleGet,"finoClientId": this.finoClientId,"aggId":  this.moduleClient.length>0? this.moduleClient[0].agg_id:'',"requestFor":"FILE","selectedSR":this.selected,"tabKey":this.tab,"requestId":fileId};
    core
      .post({
        data: request,
        url: 'demandCancel',
        method: 'post'
      })
    .then(response => {
      
      this.showMessages(response,'success');
    })
    .catch(error => {
      
      this.showMessages(error,'error');
    });
    this.selected=[];
    this.viewSrHistory("VIEW",true);
  }

fileIdSelected='';
fetchSrDataResponse:any={};
  fetchSrData(fileId){
    this.fileIdSelected=fileId;
   let request={"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": store.getters.sessLoginDataGet.clientId,"fromDate":'',"toDate":'',"requestType": "VIEW","requestModule": "SR_LIST","recordNumber": this.recordNumberSr,"finoClientId": this.finoClientId,"aggId":  this.moduleClient.length>0? this.moduleClient[0].agg_id:'',"filter_A": fileId,"filter_B": "","filter_C": "","filter_D": "","filter_E": "","tabKey":this.tab};
    core
      .post({
        data: request,
        url: 'fetchFileHist',
        method: 'post'
      })
    .then(response => {
      this.fetchSrDataResponse=response;
      this.openSr=true
      if(response.historyData.length>0){
        this.srData.push(...response.historyData);
        this.srHeaders=response.headers;
        this.setDrawerState();
        if(this.selectedAll){
          this.selectAllSr();
        }
      }
      if(response.historyData.length<=0){
        //this.historys=[];
      }
    })
    .catch(error => {
      console.log(error)
    });
  }


 isSelectedAll(){
    setTimeout(()=>{
      return this.selectedAll?true:false;
    },100)
  }

  setDrawerState(){
    store.dispatch('updateUserNavDataAc',false)
  }

 
  get clientDetails(){
    return store.getters.updateSuperInitDataGet.payload2[0];
  }
  get paginationLength() {
    if (this.historys.length === 0) {
      return 0;
    }
    // if(this.search){
    //   let data=this.historys.filter(obj=>{
    //     let values=Object.values(obj);
    //     console.log(_.includes(values, this.search));
    //     return _.includes(values, this.search) > -1;
    //   })
    //   console.log(data);
    // }

    const temp = (
      this.historys.length / this.historyResponse.pageSize
    ).toString();
    let pagesToBeAdded = 0;
    if (this.historyResponse.isEof === false) {
      pagesToBeAdded = 1;
    }
    let pages = 0;
    if (temp.includes('.')) {
      pages = +temp.split('.')[0] + 1;
      this.pageNumberToHitAPI = pages;
    } else {
      pages = +temp + pagesToBeAdded;
      this.pageNumberToHitAPI = pages;
    }
    if (this.historyResponse.isEof === true) {
      this.pageNumberToHitAPI = 0;
    }

    return pages;
  }
  changePageNumber(pageNumber: number) {
    
    if (pageNumber === this.pageNumberToHitAPI) {
      this.recordNumber = this.recordNumber+1; 
      this.pageNumberToHitAPI = 0;
      this.viewSrHistory('VIEW',false)
    }
  }

  //View SR Pagination
  get paginationLengthSr() {
    if (this.srData.length === 0) {
      return 0;
    }
    const temp = (
      this.srData.length / this.fetchSrDataResponse.pageSize
    ).toString();
    let pagesToBeAdded = 0;
    if (this.fetchSrDataResponse.isEof === false) {
      pagesToBeAdded = 1;
    }
    let pages = 0;
    if (temp.includes('.')) {
      pages = +temp.split('.')[0] + 1;
      this.pageNumberToHitAPISr = pages;
    } else {
      pages = +temp + pagesToBeAdded;
      this.pageNumberToHitAPISr = pages;
    }
    if (this.fetchSrDataResponse.isEof === true) {
      this.pageNumberToHitAPISr = 0;
    }

    return pages;
  }
  changePageNumberSr(pageNumber: number) {
    if (pageNumber === this.pageNumberToHitAPISr) {
      this.recordNumberSr = this.recordNumberSr+1; 
      this.pageNumberToHitAPISr = 0;
      this.fetchSrData(this.fileIdSelected)
    }
  }


  //View SR End

  detailsHeaders=null;
  detailsValues=null;
  transId="";
  getTransactionSummary(data,header){
    this.openSr=false;
    const obj = this.historyResponse.headers.find(item => {
      return  this.historyResponse.txnIdParamName=== item.text;
    });
    this.transId=data[obj.value];
    let request={"transactionId":data[obj.value],"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": store.getters.sessLoginDataGet.clientId,"fromDate": this.fromDate!=''? moment(this.fromDate).format("DD/MM/YYYY"):'',"toDate": this.toDate!=''?moment(this.toDate).format("DD/MM/YYYY"):'',"requestType": "VIEW","requestModule": this.reqModule,"recordNumber": 0,"finoClientId": "","aggId":"","filter_A": "","filter_B": "","filter_C": "","filter_D": "","filter_E": "","tabKey":this.tab};
    core
      .post({
        data: request,
        url: 'transdetailHist',
        method: 'post'
      })
    .then(response => {
   
      this.detailsHeaders=response.headers;
      this.detailsValues=response.historyData;
      this.transInfo=true;
      this.openSr=true;
    })
    .catch(error => {
      console.log(error)
    });
  }

  getStatusColor(status){
    switch (status && status.toUpperCase()) {
      case 'SUCCESS':
        case 'CLOSED':
          return 'color:#34a853';
          case 'CONFIRMED':
        return 'color:#293896';
  
      case 'FAILED':
        case 'EXPIRED':
        return 'color:#ea4335';

      case 'PENDING':
      case 'INITIATED':
        return 'color:#E88A00';
      default:
        return '';
    }
    return '';
  }

  get mobileTableData() {
    if(this.search){
      return this.historys.filter((obj)=>{
        for (const [key, value] of Object.entries(obj)) {
          // @ts-ignore
          if(value.includes(this.search)){
            return true;
          }
        }
      })
    }else{
    return this.historys.slice(
      (this.currentPage - 1) * this.historyResponse.pageSize,
      this.currentPage * this.historyResponse.pageSize
    );
    }
  }

  get mnDate(){
    return moment("2020-01-01").format("YYYY-MM-DD")
  }
  toMxDate=moment().format("YYYY-MM-DD");
  checkDate(){
    if(this.fromDate){
      const dateRange=this.staticData?this.getVersionInfosValues('HistoryDateRange'):'';
      let finalDate=dateRange.length>0?moment(this.fromDate).add(parseInt(dateRange[0].keyValue),'d').format('YYYY-MM-DD'):moment().add(31,'d').format('YYYY-MM-DD');
        if(moment(finalDate).isAfter(moment())){
          this.toDate="";
          // @ts-ignore
          this.$refs["child1"].clear();
          this.toMxDate=moment().format('YYYY-MM-DD');
        }else if((moment(this.toDate).diff(this.fromDate,'days')>parseInt(dateRange[0].keyValue)) || moment(this.fromDate).isAfter(this.toDate)){
          this.toDate="";
          // @ts-ignore
          this.$refs["child1"].clear();
          this.toMxDate=finalDate;
        }
        else{
          this.toMxDate=finalDate;
        }
    }else{
      this.toMxDate=moment().format('YYYY-MM-DD');
    }
}

getVersionInfosValues(key){
  if(this.staticData.payload['versionInfos']){
    return this.staticData.payload['versionInfos'].filter(obj=>{
      return obj.keyName===key;
    })
  }else{
    return [{keyValue:"31"}]
  }
  
}

  get dateRangeDays(){
    return this.superInitData?`History can be viewed within a date range of ${this.getVersionInfosValues('HistoryDateRange')[0].keyValue} days.`:'';
  }
  
  mounted() {
//     if(this.tab=='CC')
//     this.itemsModules=this.staticData.payload.ccSearchModule
    if(this.tab=='CD' || this.tab==='CLCM'){
    this.itemsModules=_.orderBy(this.staticData.payload.cdSearchModule,'displayName');
    if(this.itemsModules.length==1)
   {
     this.finoClientId=this.itemsModules[0]['value']
   }
    }
    this.superInitData=store.getters.updateSuperInitDataGet;
  
    

//     if(this.tab==='CD'){
//       let filterList;
//       filterList= this.staticData.payload.versionInfos.filter(el=>
//       {
//        return el['keyName']=='cdSrStatusFilter'}
//         );
        
//         if(filterList.length>0){
//           filterList[0]['keyValue'].split('|').forEach(element => {
//       this.srStatuses.push({"name":element,"value":element})
//     });

//   }
//   }


  }
counter=1;
headerExcel:any=[];
async fetchData(){
  try{
    if(this.$v.$invalid){
      this.$v.$touch();
      return;
    }
    this.downloadFile=true;
    let request={"tabKey":this.tab,"token":store.getters.sessLoginDataGet.sessionId,"merchantClientId": this.clientDetails.clientId,"fromDate": moment(this.fromDate).format("DD/MM/YYYY"),"toDate": moment(this.toDate).format("DD/MM/YYYY"),"requestType": 'DOWNLOAD',"requestModule": this.reqModule,"recordNumber": this.counter,"finoClientId": this.finoClientId,"aggId": this.moduleClient[0].agg_id,"filter_A": "","filter_B": "","filter_C": "","filter_D": "","filter_E": ""};
    
    const response = await axios({data: request,
      url: window.location.origin+'/MFINWeb/fetchCmsHist',
      method:'post'
    });
    if (response.data.responseCode == '099' || !response.data) {
      this.downloadFile=false;
      sToast.show({
        message: response.data.msgDesc,
        intent: "error",
        timeout: 6000
      });
      return;
    }
    response['data'].headers.forEach(element => {
      if(element.text!=response['data']['clickableColumnName']){
        this.json_fields[element.text]=element.value;
      } 
    });
    if(response['data'].headers){
      this.headerExcel=response['data'].headers;
    }
      this.dataExcel.push(...response['data']['historyData']);
      if(!response.data.isEof){
      this.counter=this.counter+1;
      this.fetchData();
    }
    else{
      this.downloadFileLoader=false;
    }
  }catch(e){
    this.downloadFile=false;
  }
  
}
fileName(){
  return moment().unix();
}
clearBtnFilter() {
  this.isFilterEnable = false;
  this.btnTxt="Search";
} 
$refs = {};

clearFilter(){
  this.historys=[];
  this.counter=1;
  this.recordNumber=1;
  this.pageNumber=1;
  this.currentPage=1;
  this.headers=[];
  this.search="";
  this.isFilterEnable = false;
  this.fromDate = "";
  this.toDate = "";
  this.historys=[];
  this.counter=1;
  this.recordNumber=1;
  this.pageNumber=1;
  this.currentPage=1;
  this.headers=[];
  this.search="";
  this.btnTxt = "Search";
  this.$v.$reset();
  this.finoClientId='';
  this.$refs["child1"].clear();
  this.$refs["child"].clear();
}






onexport () { // On Click Excel download button
    
  // export json to Worksheet of Excel
  // only array possible
  let excelData=[];
  excelData=_.cloneDeep(this.dataExcel);
  excelData.forEach((obj)=>{
    for (const [key, value] of Object.entries(obj)) {
      this.headerExcel.forEach((head)=>{
        if(head.value==key){
          obj[head.text]=value;
          if(head.text==this.historyResponse.clickableColumnName){
            delete obj[head.text];
          }
          delete obj[key];
        }else{
          delete obj[key];
        }
      })
    }
  })
  var SheetWS = XLSX.utils.json_to_sheet(excelData);
  // A workbook is the name given to an Excel file
  var wb = XLSX.utils.book_new() // make Workbook of Excel
  // add Worksheet to Workbook
  // Workbook contains one or more worksheets
  XLSX.utils.book_append_sheet(wb, SheetWS, 'Sheet1') // sheetAName is name of Worksheet
  // export Excel file
  XLSX.writeFile(wb, `${this.fileName()}.xlsx`) // name of the file is 'book.xlsx'*/
}

}
